<template>
  <button class="btn" :class="'mobile ' + props.type + ' ' + (props.disabled ? 'disabled' : '') + ' ' + locale + ' ' + props.size">
    <!-- <span class="btn-inner"> -->
      <slot></slot>
    <!-- </span> -->
  </button>
</template>
<script setup>
import { defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const props = defineProps({
  type: {
    type: String,
    default: 'yellow', // yellow blue
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'default', // default small
  },
})
</script>

<style lang="less" scoped src="./mobile_style.less"></style>